import { defineComponent as a, createBlock as n, openBlock as r, unref as p, mergeProps as c, withCtx as m, createElementVNode as l } from "vue";
import { RevIcon as s } from "@ds/components/Icon";
const d = /* @__PURE__ */ a({
  name: "IconCycle",
  __name: "IconCycle",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(t) {
    const o = t;
    return (i, e) => (r(), n(p(s), c(o, { "view-box": "0 0 24 24" }), {
      default: m(() => [...e[0] || (e[0] = [
        l("path", { d: "M12 2.25a.75.75 0 0 0 0 1.5 8.25 8.25 0 0 1 5.75 14.166V15.5a.75.75 0 0 0-1.5 0v3.485a1.25 1.25 0 0 0 1.25 1.25H21a.75.75 0 0 0 0-1.5h-1.95A9.719 9.719 0 0 0 21.75 12 9.75 9.75 0 0 0 12 2.25m-7.036 3H3a.75.75 0 0 1 0-1.5h3.523A1.25 1.25 0 0 1 7.773 5v3.5a.75.75 0 0 1-1.5 0V6.061A8.25 8.25 0 0 0 12 20.25a.75.75 0 0 1 0 1.5A9.75 9.75 0 0 1 2.25 12a9.719 9.719 0 0 1 2.714-6.75" }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  d as default
};
